import { useState, useEffect } from 'react';
import { handleWrapperMessage } from '../../services/eventHandlerService';
// Processing Loader Component
function ProcessingLoader() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-32 w-32 border-t-4 border-b-4 border-boonsOrange mb-8"></div>
        <p className="text-white text-4xl font-medium">
          Processing Payment...
        </p>
        <p className="text-xl text-gray-600">Please wait, do not remove your card</p>
      </div>
    </div>
  );
}

export default function PaymentModalWrapper({ isOpen, onClose, total, onPaymentSuccess, onPaymentFailure, onAutoCancel }) {
  const [isProcessing, setIsProcessing] = useState(false);
  const [isWaitingForCard, setIsWaitingForCard] = useState(false);
  useEffect(() => {
    const messageHandler = (event) => {
      handleWrapperMessage(event, {
        setIsWaitingForCard,
        setIsProcessing,
        onPaymentSuccess,
        onPaymentFailure,
        onClose,
        onAutoCancel
      });
    };

    window.addEventListener('message', messageHandler);
    return () => window.removeEventListener('message', messageHandler);
  }, [onPaymentSuccess, onPaymentFailure, onClose, onAutoCancel]);
  if (!isOpen) return null;

  // Show processing loader when processing payment
  if (isProcessing) {
    return <ProcessingLoader />;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black bg-opacity-80"
        onClick={async () => {
          onClose();
        }}
      />

      {/* Modal */}
      <div className="relative bg-white max-w-4xl mx-4 overflow-hidden shadow-2xl rounded-2xl">
        {/* Header */}
        <div className="bg-white px-6 py-6 flex items-center justify-between">
          <button
            onClick={async () => {
              //send message to wrapper that user clicked on back button
              const messageData = {
                type: "PAYMENT_CANCEL",
                status: "back",
              };
              if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(JSON.stringify(messageData));
                console.log("Sent PAYMENT_CANCEL to wrapper:", messageData);
              } else {
                console.warn("ReactNativeWebView not found while in wrapper mode");
              }
              onClose();
            }}
            className="w-12 h-12 flex items-center justify-center text-white rounded-xl transition-colors"
          >
            <img
              src="/images/back.png"
              alt="back"
              className="w-[50px] h-[50px] rounded-[12px]"
            />
          </button>
          <p className="text-4xl font-outfit font-medium text-textcolor absolute left-1/2 transform -translate-x-1/2">
            Your Order Total
          </p>
        </div>

        {/* Total Amount */}
        <div className="bg-white px-6 py-8 text-center">
          <div className="text-8xl font-outfit font-medium text-textcolor">
            ${total}
          </div>
        </div>

        {/* Instructions */}
        <div className="bg-paymentbg px-6 py-12 text-center">
          <p className="text-[40px] font-outfit font-medium text-textcolor mb-6 leading-relaxed">
            Please Insert/Tap Your Credit or<br />
            Debit Card To The Right
          </p>

          {/* Animated Arrows */}
          <div className="flex items-center justify-center gap-2">

            {/* Arrow 1 */}
            <img
              src="/images/cardswipeloader.png"
              alt="arrow"
              className="w-10 h-10 animate-pulse"
              style={{ animationDelay: '0s', animationDuration: '1.5s' }}
            />

            {/* Arrow 2 */}
            <img
              src="/images/cardswipeloader.png"
              alt="arrow"
              className="w-10 h-10 animate-pulse"
              style={{ animationDelay: '0s', animationDuration: '1.5s' }}
            />

            {/* Arrow 3 */}
            <img
              src="/images/cardswipeloader.png"
              alt="arrow"
              className="w-10 h-10 animate-pulse"
              style={{ animationDelay: '0s', animationDuration: '1.5s' }}
            />

          </div>

          {/* Status indicator */}
          {isWaitingForCard && (
            <div className="mt-6 flex items-center justify-center gap-2 text-green-600">
              <div className="w-3 h-3 bg-green-600 rounded-full animate-pulse"></div>
              <span className="text-lg font-medium">Ready - Waiting for card tap...</span>
            </div>
          )}
          {/* Error message */}
          {/* {error && (
            <div className="mt-6 p-4 bg-red-100 border border-red-400 rounded-lg">
              <p className="text-red-700 text-lg font-medium">
                Error
              </p>
              <button
                onClick={onClose}
                className="mt-3 px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
              >
                Close
              </button>
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
}